import React, { memo, useState, useEffect, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '@saleshandy/design-system';
import { ForwardIcon } from '../../../../../../../../shared/svg';
import type { IProps } from './types';
import CallForwardingSettingsContent from '../../../phone-number-settings/components/phone-number-settings-content/components/call-forwarding-settings/call-forwarding-settings-content';
import { RequestStatus } from '../../../../../../../../shared/enums/request-status';


const SetCallForwardingRuleModal: React.FC<IProps> = ({
    show,
    onClose,
    onSubmit,
    bulkUpdateForwardingRuleStatus,
    updateForwardingRuleStatus,
}) => {
    const [isForwardingConfigurationValid, setIsForwardingConfigurationValid] = useState<boolean>(false);
    const [isForwardingEnabled, setIsForwardingEnabled] = useState<boolean>(true);
    const [settingsToApply, setSettingsToApply] = useState<Array<{ code: string; value: string | null }>>([]);
    const isApplyButtonPending = updateForwardingRuleStatus === RequestStatus.Pending || 
    bulkUpdateForwardingRuleStatus === RequestStatus.Pending;

    const isApplyButtonDisabled = useMemo(() => {
        if (isForwardingEnabled) {
            return !isForwardingConfigurationValid || isApplyButtonPending;
        }
        return isApplyButtonPending
    }, [isForwardingEnabled, isForwardingConfigurationValid, isApplyButtonPending]);

    // Reset state when modal closes
    useEffect(() => {
        if (!show) {
            setIsForwardingConfigurationValid(false);
            setSettingsToApply([]);
        }
    }, [show]);

    const handleConfirm = () => {
        onSubmit?.(settingsToApply);
    };

    const handleCancel = () => {
        onClose();
    };

    const getIsForwardingConfigurationValid = (isValid: boolean) => {
        setIsForwardingConfigurationValid(isValid);
    }
    return (
        <Modal
            show={show}
            onHide={handleCancel}
            aria-labelledby="set-call-forwarding-rule-modal-title"
            className="set-call-forwarding-rule-modal"
            backdrop="static"
            centered
        >
            <Modal.Header className="set-call-forwarding-rule-modal__header">
                <div className="set-call-forwarding-rule-modal__header-content">
                    <ForwardIcon width={20} height={20} className="set-call-forwarding-rule-modal__header-icon" />
                    <Modal.Title id="set-call-forwarding-rule-modal-title" className="set-call-forwarding-rule-modal__title">
                        Set Call Forwarding Rule
                    </Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body className="set-call-forwarding-rule-modal__body">
                <CallForwardingSettingsContent
                    isModal={true}
                    getIsForwardingConfigurationValid={getIsForwardingConfigurationValid}
                    setIsForwardingEnabled={setIsForwardingEnabled}
                    setSettingsToApply={setSettingsToApply}
                />
            </Modal.Body>
            <Modal.Footer className="set-call-forwarding-rule-modal__footer">
                <div className="set-call-forwarding-rule-modal__footer-actions">
                    <Button
                        onClick={handleCancel}
                        variant="secondary"
                        className="set-call-forwarding-rule-modal__cancel-btn"
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleConfirm}
                        className="set-call-forwarding-rule-modal__confirm-btn"
                        disabled={isApplyButtonDisabled}
                        isLoading={isApplyButtonPending}
                        loadingText="Applying..."
                    >
                        Confirm
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default memo(SetCallForwardingRuleModal);

